import { SelectOption } from './types';

export const flattenArr = (arr: SelectOption[]) => {
  let result: SelectOption[] = [];

  for (const item of arr) {
    if (item.children) {
      result.push(...flattenArr(item.children));
    } else {
      result.push(item);
    }
  }

  return result;
};

export const scrollIntoView = (container: HTMLElement, target: HTMLElement) => {
  const containerRect = container.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();

  if (targetRect.top < containerRect.top) {
    container.scrollTop -= containerRect.top - targetRect.top;
  } else if (targetRect.bottom > containerRect.bottom) {
    container.scrollTop += targetRect.bottom - containerRect.bottom;
  }
};
